import { Component, AfterViewInit } from '@angular/core';

import { GlobalState } from './global.state';
// import { BaThemePreloader, BaThemeSpinner } from './theme/services';

import 'style-loader!./app.component.scss';
import 'style-loader!./theme/initial.scss';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements AfterViewInit {
  isMenuCollapsed: boolean;

  constructor(private _state: GlobalState,
              // private _spinner: BaThemeSpinner
            ) {
    this.isMenuCollapsed = true;
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
       this.isMenuCollapsed = isCollapsed;
     });
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    // BaThemePreloader.load().then((values) => {
    //   this._spinner.hide();
    // });
  }

  public spinnerShow() {
    // this._spinner.show();
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/app.component.ts